import Pristine from "pristinejs/dist/pristine.js";
import InputUpload from "./input-upload.js";
export default class FormSubmitEvent{
    
    constructor(element) {
        this._form = element;
        this._duplicateBtns = this._form.querySelectorAll('.js-form-submit-event-duplicate-button');
        this._inputUploadMultiples = this._form.querySelectorAll('.js-input-upload.is-multiple input');
        this._submitBtn = this._form.querySelector('.js-form-submit-event-submit-btn');
        this._toggle = this._form.querySelector('.js-form-submit-event-toggle');
        this._addressSearch = this._form.querySelector('.js-input-address-search');
        this._addressValue = this._form.querySelector('.js-input-address-input');
        
        
        Pristine.addMessages('fr', {
            required: "Ce champ est requis",
            email: "L'adresse e-mail est invalide",
            number: "Ce champ requiert un nombre",
            integer: "Ce champ requiert une valeur entière",
            url: "Ce champ requiert une URL valide",
            tel: "Ce champ requiert un numéro de téléphone valide",
            maxlength: "La longueur de ce champ doit être inférieure à ${1}",
            minlength: "La longueur de ce champ doit être supérieure à ${1}",
            min: "La valeur minimale pour ce champ est ${1}",
            max: "La valeur maximale pour ce champ est ${1}",
            pattern: "Veuillez respecter le format requis",
            equals: "Les deux champs ne correspondent pas",
            default: "Veuillez entrer une valeur correcte"
        });
        Pristine.setLocale('fr');
        
        let currentUnvalidFilename = '';
        let currentUnvalidFileExtension = '';

        Pristine.addValidator("filesize", function(value, maxSizeInMo) {
            let maxSizeInOctets = parseInt(maxSizeInMo) * 1024 * 1024;
            for (const file of this.files) {
                if (file.size > maxSizeInOctets) {
                    currentUnvalidFilename = file.name;
                    return false;
                }
            }
            return true;

        },function(value, value2){ return `Le fichier ${currentUnvalidFilename} est trop volumineux, la taille maximale est de ${value2[1]}Mo`}, 5, false);

        Pristine.addValidator("extensions", function(value, extensions) {
            for (const file of this.files) {
                let extension = file.name.split('.').pop().toLowerCase();
                let validExtensions = extensions.split(';');
                if(!validExtensions.includes(extension)){
                    currentUnvalidFilename = file.name;
                    currentUnvalidFileExtension = extension;
                    return false;
                }
            }
            return true;

        },function(value, value2){
            let validExtensions = value2[1].split(';').map(ext => '.' + ext).join(' ');
            
            return `Seul les extensions ${validExtensions} sont autorisées. Le fichier ${currentUnvalidFilename} a pour extension .${currentUnvalidFileExtension}`
        }, 5, false);


        this.pristine = new Pristine(this._form, {}, true);
        
        
        this.init();
        this.bindEvents();
    }
    
    init(){
        
    }
    
    bindEvents(){
         
        this._toggle.addEventListener('click', (e) => {
            e.preventDefault();
            this._addressSearch.removeAttribute('required');
            this._addressSearch.removeAttribute('data-to-validate');
            this._addressSearch.value = '';
            this._addressValue.value = '';
            let _target = this._form.querySelector(this._toggle.getAttribute('data-target'));
            _target.classList.remove('d-none');
        });
        
        this._form.addEventListener('submit',  (e) => {
                
            if(!this.pristine.validate(this._form.querySelectorAll('[data-to-validate="true"]'))){
                e.preventDefault();
                
                let _firstError = this._form.querySelector('.has-danger');
                _firstError.scrollIntoView();
            }
            
        });
        
        app.nodesEventListener('click', this._duplicateBtns, (el,n,e) => {
            e.preventDefault();
            let target = document.querySelector(el.getAttribute('data-target'));
            this.duplicateTemplate(target);
        });
        app.nodesEventListener('input-upload:change', this._inputUploadMultiples, (el,n,e) => {
           this.pristine.validate(el);
        });
    }
    
    duplicateTemplate(target){
        let _clone = target.cloneNode(true);
        let id = _clone.getAttribute('id');
        _clone.setAttribute('data-duplicate-id', id);
        
        _clone.removeAttribute('id');
        
        let _otherClones = this._form.querySelectorAll('[data-duplicate-id="'+id+'"]');
        let index = _otherClones.length + 1;
        
        this.setIndexToClone(_clone, index);
        
        if(_otherClones.length){
            _otherClones[_otherClones.length - 1].insertAdjacentElement('afterend',_clone);
        }
        else{
            target.insertAdjacentElement('afterend',_clone);
        }
        
        let _remove = _clone.querySelector('.js-form-submit-event-duplicate-remove');
        _remove.classList.remove('d-none');
        
        _remove.addEventListener('click', () => {
           _clone.remove();
            this.onRemoveClone(id); // Update indexes;
        });
        
        // Init various form controls
        _clone.querySelectorAll('.js-input-upload').forEach(el => {
           let inputUpload = new InputUpload(el);
           if(!inputUpload.isMultiple){
               inputUpload.updateTemplate();
           }
        });
        
        
        
        this.pristine.destroy();
        this.pristine = new Pristine(this._form);
    }
    
    setIndexToClone(_clone, index){
        _clone.querySelectorAll('.js-form-submit-event-duplicate-count').forEach(el => {
            el.innerText = index + 1;
        });

        _clone.querySelectorAll('[name], [for]').forEach(el => {
            if (el.name) {
                el.name = el.name.replace(/\[\d+]/, `[${index}]`);
            }
            if (el.getAttribute('for')) {
                el.setAttribute('for', el.getAttribute('for').replace(/\[\d+]/, `[${index}]`));
            }
            if(el.value){
                el.value = '';
            }
            if(el.checked){
                el.checked = false;
            }
        });
    }
    
    onRemoveClone(id){
        let _clones = this._form.querySelectorAll('[data-duplicate-id="'+id+'"]');
        _clones.forEach((el,n) => {
            this.setIndexToClone(el, n + 1);
        });
    }
    
}